import { GoogleSignin } from '@react-native-google-signin/google-signin';
import { env } from 'app/lib/env';
import { APP_SCHEME } from 'app/../app.config.json';
import { type CognitoUserPoolConfig } from '@aws-amplify/core';
import { isMobileNative } from 'app/utils/web-helpers';

if (isMobileNative) {
  GoogleSignin.configure({
    scopes: ['email', 'profile', 'openid'],
    offlineAccess: true,
    webClientId: env.GOOGLE_CLIENT_ID,
  });
}

/**
 * Gets the current config object
 */
export const AmplifyAuthConfiguration = {
  // region: env.COGNITO_AWS_REGION,
  userPoolId: env.COGNITO_USER_POOL_ID,
  userPoolClientId: env.COGNITO_CLIENT_ID,
  // authenticationFlowType: 'CUSTOM_AUTH',
  loginWith: {
    oauth: {
      domain: 'partage-club-dev.auth.ca-central-1.amazoncognito.com',
      scopes: ['phone', 'email', 'profile', 'openid'],
      redirectSignIn: [`${APP_SCHEME}://authentication/`],
      redirectSignOut: [`${APP_SCHEME}://main/`],
      responseType: 'code', // or 'token', note that REFRESH token will only be generated when the responseType is code
    },
  },
} satisfies CognitoUserPoolConfig;
